export default "__VITE_ASSET__DTfCrOwd__"